import { httpsCallable } from "firebase/functions";

import { cloudFunctions } from "./getFunctions";
import { CloudFunctionResponse } from "@fixeduy/restaurantestypes";

export interface CambiarEstadoPedidoParams {
  pedidoId: string;
  estado: string;
}


const cambiarEstadoPedido = async (
  data: CambiarEstadoPedidoParams
): Promise<CloudFunctionResponse> => {
  const payload = { func: "cambiarEstadoPedido", params: data } as any;

  const run = httpsCallable<any, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );

  try {
    const result = await run(payload);
    const out = result.data as CloudFunctionResponse;

    return {
      exito: !!out?.exito,
      errorMsg: out?.errorMsg ?? "No se pudo cambiar el estado del pedido",
      adicionalData: out?.adicionalData
    } as CloudFunctionResponse;
  } catch (e: any) {
    return {
      exito: false,
      errorMsg:
        (typeof e?.message === "string" && e.message) ||
        "No se pudo cambiar el estado del pedido"
    } as CloudFunctionResponse;
  }
};

export { cambiarEstadoPedido };

